import classnames from 'classnames';
import { useTranslations } from 'next-intl';
import React from 'react';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { IconPhotoCamera16 } from '@cineamo/ui/src/icons/ic-photoCamera';

type AllImagesButtonProps = {
    domainConfiguration: DomainConfigurationDto;
    /** Total number of images available across the whole gallery (building + all cinema rooms). */
    count: number;
    className?: string;
    onClick?: () => void;
};

const AllImagesButton: React.FC<AllImagesButtonProps> = ({ domainConfiguration, count, className, onClick }) => {
    const t = useTranslations();
    return (
        <span
            role="button"
            tabIndex={0}
            aria-label={t('info.show-all-images', { count })}
            className={classnames(
                className,
                'flex flex-row items-center space-x-4 px-16 py-4/20 backdrop-blur rounded-16',
                'cursor-pointer clickable-element'
            )}
            style={
                domainConfiguration
                    ? {
                          backgroundColor: `${domainConfiguration.style.backgroundColor.slice(0, 7)}50`,
                          color: domainConfiguration.style.onBackgroundColor
                      }
                    : undefined
            }
            onClick={() => onClick && onClick()}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    if (onClick) {
                        onClick();
                    }
                }
            }}>
            <IconPhotoCamera16 />
            <span>{count}</span>
        </span>
    );
};

export default AllImagesButton;
